export default "/images/clip.png?403d0536fea8b2a9f4dbf0505e875694";